import { Instance } from 'mobx-state-tree'
import { RecursiveRemoveUndefined } from '../../utils'
import { PlayerStatsEntityModelBase } from './PlayerStatsEntityModel.base'

/* The TypeScript type of an instance of PlayerStatsEntityModel */
export interface PlayerStatsEntityModelType extends RecursiveRemoveUndefined<Instance<typeof PlayerStatsEntityModel>> {}

/* A graphql query fragment builders for PlayerStatsEntityModel */
export {
  selectFromPlayerStatsEntity,
  playerStatsEntityModelPrimitives,
  PlayerStatsEntityModelSelector
} from './PlayerStatsEntityModel.base'

/**
 * PlayerStatsEntityModel
 */
export const PlayerStatsEntityModel = PlayerStatsEntityModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
